
import React from 'react';
import AdminLayoutWithSubscription from '@/components/admin/AdminLayoutWithSubscription';
import SupportManagementPage from '@/components/support/SupportManagementPage';
import { useAdminSettings } from '@/hooks/useAdminSettings';

const AdminSupportManagement = () => {
  const { isLoading, user, handleLogout } = useAdminSettings();
  
  return (
    <AdminLayoutWithSubscription
      isLoading={isLoading}
      onLogout={handleLogout}
      userRole={user?.role}
    >
      <SupportManagementPage />
    </AdminLayoutWithSubscription>
  );
};

export default AdminSupportManagement;
